module.exports = __webpack_public_path__ + "media/trailer_2025.7aa14089.mp4";